import { render, staticRenderFns } from "./DesiredDeliveryAdd.vue?vue&type=template&id=fef433de&"
import script from "./DesiredDeliveryAdd.vue?vue&type=script&lang=js&"
export * from "./DesiredDeliveryAdd.vue?vue&type=script&lang=js&"
import style0 from "./DesiredDeliveryAdd.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports